/**
 * 与猎聘同道App交互
 */
export function share4App(defaluts) {
  let data;
  if(defaluts && defaluts.type){
    data = {
      type: [], //设置类型
      shareTitle: '',
      title: '',
      imgUrl: '', //分享的图片地址
      shareUrl: '', //分享的链接
      desc: '', //分享的内容
      mediaType: '', //分享到微信的样式：0卡片 1大图片
      thumburl: '', //分享到微信时的卡片样式中的小缩略图,mediaType为1时，这个参数可不写
      showshare: false, //APP分享按钮不显示,只有安卓需要设置
      isBackUrl: null //function type==13时的回调
    }
    console.log(data)
    Object.assign(data, defaluts);
  } else if (defaluts && defaluts.nativeLink) {
    data = {
      nativeLink: '', // 完整的url地址
    };
    Object.assign(data, defaluts);
  } else {
    /**
     * 新的调用方式  参考：http://wiki.lietou.com/pages/viewpage.action?pageId=24711165
     * scheme://host/firstPathLevel/secondPathLevel?s=xxx&params={key: 'value', ...}
     * scheme：lptd/lpre/lpcp
     * host：lp  固定值
     * bridge 即 firstPathLevel
     *   页面：p
     *   功能：f
     * bridgeType 即 secondPathLevel
     *   页面：job_detail, job_home_subscribe
     *   功能：wx_share, wx_pay
     * source 即 s 来源（原生App/H5/微信小程序)
     */
    data = {
      scheme: 'lptd',
      host: 'lp',
      bridge: 'p',
      bridgeType: 'wx_mini', /* 必传 */
      source: 'h5',
      params: null
    }
    Object.assign(data, defaluts);
  }
  // userAgent
  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
  let isLptdAndroid = (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) && u.indexOf('android-tongdao-app') > -1;
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  let isLptdIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) && u.indexOf('ios-tongdao-app') > -1 || u.indexOf('ios-jisu-app') > -1;
  let iosBigVersion = isiOS && u.match(/os\s+(\d+)/i)[1] - 0;
  let lptdIosOldVersionRuleVerify = false;

  try {
    /**
     * 判断猎聘同道 ios 版本号
     * 描述: 为了兼容老 App 版本, App 强制升级后应去掉此段代码
     * 规则:
     * 1. 0.0.0 - 3.0.0
     * 2. 3.0.0 - 3.19.0(不包含)
     * 3. 3.19.0 - 3.19.8(不包含)
     */
    let lptdIosVersion = isLptdIos && u.match(/ios-tongdao-app\/(\d+\.\d+\.\d+)/i)[1].split('.').map((item) => {
      return Number(item);
    });
    let lptdIosVersionRule1 = lptdIosVersion[0] < 3;
    let lptdIosVersionRule2 = lptdIosVersion[0] === 3 && lptdIosVersion[1] < 19;
    let lptdIosVersionRule3 = lptdIosVersion[0] === 3 && lptdIosVersion[1] === 19 && lptdIosVersion[2] < 8;
    lptdIosOldVersionRuleVerify = lptdIosVersionRule1 || lptdIosVersionRule2 || lptdIosVersionRule3;
  } catch (e) {
    console.log(e);
  }

  // 发送数据前置处理函数
  function lptdSetShareData(callbackFn){
    if(data.type){
      console.log(data.type, 'data.type->')
      data.type.forEach((val, index) => {
        let tdData;
        switch (val) {
          case 9:
            tdData = {
              type: 9,
              entityId: '', // 直接传一个空字符串
              jobKind: data.jobKind, //职位类型
              jobId: data.jobId, //职位ID
              jobTitle: data.jobTitle, //职位名称
              asFrom: data.asFrom,
              selectIndex: data.selectIndex,
              yt_eid: data.yt_eid || '',
              yt_pid: data.yt_pid || '',
              yt_did: data.yt_did || ''
            };
            break;
          case 11:
            tdData = {
              type: 11,
              userId: data.userId
            }
            break;
          case 12:
            tdData = {
              type: 12,
              entityId: '', // 直接传一个空字符串
              cid: data.cid, //企业ID
              selected: 1, //0 1 2
              yt_eid: data.yt_eid || '',
              yt_pid: data.yt_pid || '',
              yt_did: data.yt_did || '',
              subJobKind: data.subJobKind || '', // 企业主页，新的版本场景下需要传subJobKind字段，不传，默认为空兼容以前的老版本 0：精英职位，1代表自由职位
            }
            break;
          case 13:
            tdData = {
              type: 13,
              url: window.location.href
            };
            if(isiOS){
              let backFn = function() {
                bridge.send(JSON.stringify({
                  type: 13,
                  url: window.location.href
                }));
              };
              data.isBackUrl(backFn);
            }
            break;
          case 14:
            tdData = {
              type: 14,
              content: data.content
            };
            break;
          case 16:
            tdData = {
              type: 16,
              title: data.title,
              shareTitle: data.shareTitle,
              img: data.imgUrl,
              url: data.shareUrl,
              content: data.desc,
              mediaType: data.mediaType,
              thumburl: data.thumburl
            };
            break;
          case 17:
            tdData = {
              type: 17,
              showshare: data.showshare
            };
            break;
          case 20:
            tdData = {
              type: 20,
              isRefresh: data.isRefresh,
              lanKind: data.lanKind
            };
            break;
          case 21:
            tdData = {
              type: 21,
              selectJobType: data.selectJobType,
            };
            break;
          case 23:
            tdData = {
              type: 23,
              user_id: data.user_id
            };
            break;
          case 24:
            tdData = {
              type: 24,
              isUpdate:data.isUpdate,
              canBack:data.canBack
            };
            break;
          case 26:
          case 32:
          case 33:
            tdData = {
              type: val,
              url: data.url
            };
            break;
          case 28:
            tdData = {
              type: 28,
              isFinish: data.isFinish
            };
            break;
          case 29:
          case 59:
            tdData = {
              type: val,
              target: data.target || ''
            };
            break;
          case 35:
            tdData = {
              type: 35,
              feedBackType: data.feedBackType || 5
            };
            break;
          case 40:
            tdData = {// 职位搜索页
              type: val,
              searchKeyword:data.searchKeyword
            };
            break;
          case 42:
            tdData = {
              type: val,
              backUrl: data.backUrl
            };
            break;
          case 44:
          case 45:
          case 57:
            tdData = {
              type: val,
              idNumber: data.idNumber,
              name: data.name
            };
            break;
          case 46:
          case 47:
          case 48:
            tdData = {
              type: val,
              lanKind: data.lanKind
            };
            break;
          case 53://唤起分享浮层
            tdData = {
              type: val,
              friendTLogCode: data.friendTLogCode || '',//分享到朋友
              friendsTLogCode: data.friendsTLogCode || ''//分享到朋友圈
            }
            break;
          case 55://关闭 Webview, 自动回退到原生页面
            tdData = {
              type: val,
              jobStatus: data.jobStatus || '',//悬赏红包成功状态 1 红包职位, 0 普通职位
              unitPrice: data.unitPrice || ''//单个悬赏红包金额
            }
            break;
          case 56:
            tdData = {
              type: val,
              target:data.target,
              idNumber: data.idNumber,
              name: data.name
            };
            break;
          case 63:
            tdData = {// 他人简历页
              type: val,
              jobId:data.jobId,
              userId: data.userId,
              userName: data.userName
            };
            break;
          case 68:
            tdData = {// 右上角三个点
              type: val,
              showMoreButton:data.showMoreButton
            };
            break;
          case 70:
            tdData = {// 简历意向页
              type: val,
              resId:data.resId,
            };
            break;
          case 72:
          tdData = {// 分享微信好友小程序
            type: val,
            shareTitle:data.shareTitle,
            shareURL:data.shareURL,
            path:data.path,
            hdImage:data.hdImage
          };
          break;
          case 74:
          tdData = {// android 登陆失效时候的调用
            type: val,
            url:data.url,
            code:data.code,
            msg:data.msg
          };
          break;
          default:
            tdData = {
              type: val
            };
            break;
        }
        callbackFn && callbackFn(JSON.stringify(tdData));
      });
    } else if (defaluts && defaluts.nativeLink) {
      if (/^lp\w{2}:\/\//.test(defaluts.nativeLink)) {
        callbackFn && callbackFn(data.nativeLink);
      }
    } else {
      let {scheme,host,bridge,bridgeType,source,params} = data;
      let totalParam = params ? `s=${source}&params=${JSON.stringify(params)}` : `s=${source}`;
      callbackFn && callbackFn(`${scheme}://${host}/${bridge}/${bridgeType}?${encodeURIComponent(totalParam)}`);
    }
  }

  // 与 Native 通信
  if (isLptdAndroid && window.tongdao) {
    lptdSetShareData(function(tdData){
      window.tongdao.callbackFromH5(tdData);
    });
  } else if (isLptdIos) {
    if (lptdIosOldVersionRuleVerify) {
      // App3.19.8以下版本, 仍使用老的调用方式
      function connectWebViewJavascriptBridge(callback) {
        if (window.WebViewJavascriptBridge) {
          callback(WebViewJavascriptBridge);
        } else {
          document.addEventListener('WebViewJavascriptBridgeReady', function () {
            callback(WebViewJavascriptBridge);
          }, false);
        }
      }
      connectWebViewJavascriptBridge(function (bridge) {
        lptdSetShareData(function (tdData) {
          bridge.send(tdData);
        });
      });
    } else {
      // App3.19.8 及以上版本, IOS 升级了通信库
      function setupWebViewJavascriptBridge(callback) {
        if (window.WebViewJavascriptBridge) {
          return callback(WebViewJavascriptBridge);
        } else {
          document.addEventListener('WebViewJavascriptBridgeReady', function () {
            return callback(WebViewJavascriptBridge);
          }, false);
        }
        if (window.WVJBCallbacks) {
          return window.WVJBCallbacks.push(callback);
        }
        window.WVJBCallbacks = [callback];
        var WVJBIframe = document.createElement('iframe');
        WVJBIframe.style.display = 'none';
        WVJBIframe.src = 'https://__bridge_loaded__';
        document.documentElement.appendChild(WVJBIframe);
        setTimeout(function () {
          document.documentElement.removeChild(WVJBIframe);
        }, 0);
      }
      setupWebViewJavascriptBridge(function (bridge) {
        // TODO: App 调用 JavaScript 方法(暂时用不到)
        bridge.registerHandler('testJavascriptHandler', function (data, responseCallback) {
          var responseData = { 'Javascript Says': 'Right back atcha!' }
          responseCallback(responseData);
        })
        // JavaScript 给 App 发送信息
        lptdSetShareData(function (tdData) {
          bridge.callHandler('testObjcCallback', tdData, function (response) { });
        });
      });
    }
  }
}
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/crowd_fund/active1017/share.js